import React from 'react'

import Letter from 'components/CommonUI/svgIcons/Letter'
import LinkedinIcon from 'components/CommonUI/svgIcons/LinkedinIcon'
// import TwitterIcon from 'components/CommonUI/svgIcons/TwitterIcon'


const HelpSupportContacts = () => {
    return (
        <div className="contacts-container">
            <div className="email help-class">
                <Letter className="help-class"/>
                <a className="contacts-link" href="mailto:support@ampenergy.io">support@ampenergy.io</a>
            </div>
            <div className="help-class">
            <a className="icons" href="https://www.linkedin.com/company/amp-ai/" target="_blank" rel="noopener noreferrer">
                <LinkedinIcon/>
            </a>
            {/*<Link className="icons" to="/">*/}
            {/*    <TwitterIcon/>*/}
            {/*</Link>*/}
            </div>
        </div>
    )
}

export default HelpSupportContacts

